import { Row } from 'farmhub-ui-core';
import styled from 'styled-components';

import { overlay } from 'styled';

export const Wrapper = styled(Row)`
  width: 100%;
  height: auto;
  border: 1px solid ${props => props.theme.colors.border.main};
  border-radius: ${props => props.theme.radius.md};
  padding: 8px ${p => p.theme.app.padding.vertical};
  margin: 0px ${p => p.theme.app.padding.vertical};
`;

export const WrapperBottom = styled.div`
  width: 100%;
  height: calc(100% - 12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px 0px;
`;

export const WrapperBottomMobile = styled.div`
  width: 100%;
  height: calc(100% - 12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${p => p.theme.app.padding.vertical} 0px;
  overflow-y: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const WrapperItem = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px 4px 0px 12px;
  overflow-y: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const WrapperItemMobile = styled.div`
  width: 100%;
  height: 100%;

  overflow-y: scroll;
  overflow-x: hidden;

  ${overlay}
`;

export const WrapperItemEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const PaginationWrapper = styled(Row)`
  li:has(.ant-pagination-item-container) {
    width: 26px;
    min-width: 26px;
  }
`;

export const PopupRow = styled(Row)`
  height: ${p => p.theme.select.height.lg};
  padding: ${p => p.theme.app.padding.horizontal};
`;

export const MobileWrapper = styled.div<{ active: boolean }>`
  width: 100%;
  padding: ${p => p.theme.app.padding.vertical}
    ${p => p.theme.app.padding.horizontal} !important;
  position: relative;

  cursor: pointer;

  transition: all 0.4s;

  &:hover {
    &::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: ${props => props.theme.radius.md};
      background: ${props => props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  svg {
    path {
      fill: ${props => props.theme.colors.primary.main};
    }
  }

  ${props =>
    props.active
      ? `&::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: ${props.theme.radius.md};
      background: ${props.theme.colors.primary.main} !important;
      opacity: 0.1;
      position: absolute;
      top: 0;
      left: 0;
    }`
      : ''}
`;
